module.exports = __webpack_public_path__ + "img/1486124744.a46cac99.jpg";